"use strict";

exports.__esModule = true;
exports.getGoalsByTeams = exports.getTeamsIds = exports.getTeam = void 0;

var tslib_1 = require("tslib");

var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var date_fns_1 = require("date-fns");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var _config_1 = tslib_1.__importDefault(require("../../../config"));

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  font-size: ", ";\n  display: flex;\n  flex-direction: column;\n"])), polished_1.rem(13));
var Match = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  border-bottom: ", " solid #eee;\n  &:last-child {\n    border-bottom: 0;\n  }\n  /* min-height: ", "; */\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  border-bottom: ", " solid #eee;\n  &:last-child {\n    border-bottom: 0;\n  }\n  /* min-height: ", "; */\n"])), polished_1.rem(1), polished_1.rem(85));
var PrimaryMatchInfo = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  ", " {\n    width: 60%;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  ", " {\n    width: 60%;\n  }\n"])), utilities_1.mb('m'));
var TeamName = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(13));
var TeamLogo = styled_components_1["default"](Image_1["default"])(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject([""], [""])));
var Team = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  width: 33.33%;\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  width: 33.33%;\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_a) {
  var align = _a.align;

  if (align === 'left') {
    return styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: space-around;\n        ", " {\n          justify-content: flex-end;\n          text-align: right;\n          flex-direction: row;\n          width: 40%;\n          ", " {\n            padding-right: ", ";\n          }\n        }\n      "], ["\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: space-around;\n        ", " {\n          justify-content: flex-end;\n          text-align: right;\n          flex-direction: row;\n          width: 40%;\n          ", " {\n            padding-right: ", ";\n          }\n        }\n      "])), utilities_1.mb('m'), TeamName, polished_1.rem(10));
  }

  return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      flex-direction: column;\n      text-align: center;\n      justify-content: space-around;\n      ", " {\n        justify-content: flex-start;\n        text-align: left;\n        flex-direction: row;\n        width: 40%;\n        ", " {\n          padding-left: ", ";\n        }\n      }\n    "], ["\n      flex-direction: column;\n      text-align: center;\n      justify-content: space-around;\n      ", " {\n        justify-content: flex-start;\n        text-align: left;\n        flex-direction: row;\n        width: 40%;\n        ", " {\n          padding-left: ", ";\n        }\n      }\n    "])), utilities_1.mb('m'), TeamName, polished_1.rem(10));
});
var TimePlace = styled_components_1["default"].div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  text-align: center;\n  ", " {\n    display: none;\n  }\n"], ["\n  font-size: ", ";\n  color: ", ";\n  text-align: center;\n  ", " {\n    display: none;\n  }\n"])), polished_1.rem(12), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, utilities_1.mb('m'));
var ScoreBoard = styled_components_1["default"].div(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  width: 33.33%;\n  margin: 0 ", ";\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n"], ["\n  width: 33.33%;\n  margin: 0 ", ";\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n"])), polished_1.rem(10));
var AdditionalMatchInfo = styled_components_1["default"].div(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  width: 20%;\n  text-align: ", ";\n  font-size: ", ";\n  color: ", ";\n  display: none;\n  ", " {\n    display: flex;\n    justify-content: center;\n    align-items: ", ";\n    flex-direction: column;\n  }\n"], ["\n  width: 20%;\n  text-align: ", ";\n  font-size: ", ";\n  color: ", ";\n  display: none;\n  ", " {\n    display: flex;\n    justify-content: center;\n    align-items: ", ";\n    flex-direction: column;\n  }\n"])), function (_a) {
  var align = _a.align;
  return align === 'left' ? 'left' : 'right';
}, polished_1.rem(12), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, utilities_1.mb('m'), function (_a) {
  var align = _a.align;
  return align === 'left' ? 'flex-start' : 'flex-end';
});
var Score = styled_components_1["default"].div(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});

exports.getTeam = function (match, teamSide) {
  return match.teams.find(function (i) {
    return sportnet_utilities_1.getProp(i, ['additionalProperties', 'homeaway'], '') === teamSide;
  });
};

exports.getTeamsIds = function (match) {
  var homeTeam = exports.getTeam(match, 'home');
  var homeTeamId = homeTeam ? homeTeam._id : match.teams[0]._id;
  var awayTeam = exports.getTeam(match, 'away');
  var awayTeamId = awayTeam ? awayTeam._id : match.teams[1]._id;
  return {
    homeTeamId: homeTeamId,
    awayTeamId: awayTeamId
  };
};

exports.getGoalsByTeams = function (match) {
  var _a = exports.getTeamsIds(match),
      homeTeamId = _a.homeTeamId,
      awayTeamId = _a.awayTeamId;

  var homeTeamGoals = 0;
  var awayTeamGoals = 0;

  if (sportnet_utilities_1.getProp(match, ['protocol', 'events'], []).length) {
    homeTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
      if (e.team === homeTeamId && e.eventType === 'goal' && e.type !== 'dropped' && e.phase !== 'shootout' || e.team === awayTeamId && e.eventType === 'goal' && e.type === 'dropped') {
        return acc + 1;
      }

      return acc;
    }, homeTeamGoals);
    awayTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
      if (e.team === awayTeamId && e.eventType === 'goal' && e.type !== 'dropped' && e.phase !== 'shootout' || e.team === homeTeamId && e.eventType === 'goal' && e.type === 'dropped') {
        return acc + 1;
      }

      return acc;
    }, awayTeamGoals);
  } else if (match.protocol) {
    homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
      if (e.team === homeTeamId && e.eventType === 'goal' && e.phase !== 'shootout' && e.type !== 'dropped' || e.team === awayTeamId && e.eventType === 'goal' && e.type === 'dropped') {
        return acc + 1;
      }

      return acc;
    }, homeTeamGoals);
    awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
      if (e.team === awayTeamId && e.eventType === 'goal' && e.phase !== 'shootout' && e.type !== 'dropped' || e.team === homeTeamId && e.eventType === 'goal' && e.type === 'dropped') {
        return acc + 1;
      }

      return acc;
    }, awayTeamGoals);
  }

  return {
    homeTeamGoals: homeTeamGoals,
    awayTeamGoals: awayTeamGoals
  };
};

var WidgetMatchesList = function (_a) {
  var data = _a.data,
      renderEmpty = _a.renderEmpty;

  var getSportSectorPhases = function (sport) {
    var phases = data.data && data.data.sportSectorPhases.find(function (i) {
      return i._id === sport;
    });
    return phases ? phases.items : [];
  };

  var getGoalsByMatchPart = function (match) {
    var _a = exports.getTeamsIds(match),
        homeTeamId = _a.homeTeamId,
        awayTeamId = _a.awayTeamId;

    var sportSectorPhases = getSportSectorPhases(match.rules.sport_sector);
    return (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, event) {
      var _a, _b, _c, _d;

      if (event.eventType === 'goal' && event.phase !== 'shootout') {
        var otherTeamId = event.team === homeTeamId ? awayTeamId : homeTeamId;

        if (event.type === 'dropped') {
          return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[event.phase] = tslib_1.__assign(tslib_1.__assign({}, acc[event.phase] || {}), (_b = {}, _b[otherTeamId] = (acc[event.phase] ? acc[event.phase][otherTeamId] || 0 : 0) + 1, _b)), _a));
        }

        return tslib_1.__assign(tslib_1.__assign({}, acc), (_c = {}, _c[event.phase] = tslib_1.__assign(tslib_1.__assign({}, acc[event.phase] || {}), (_d = {}, _d[event.team] = (acc[event.phase] ? acc[event.phase][event.team] || 0 : 0) + 1, _d)), _c));
      }

      return acc;
    }, sportSectorPhases.reduce(function (acc, phase) {
      var _a, _b;

      if (sportnet_utilities_1.getProp(match, ['timer', phase._id, 'start', 'date'])) {
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[phase._id] = (_b = {}, _b[homeTeamId] = 0, _b[awayTeamId] = 0, _b), _a));
      }

      return acc;
    }, {}));
  };

  var getShootoutGoals = function (match) {
    var _a = exports.getTeamsIds(match),
        homeTeamId = _a.homeTeamId,
        awayTeamId = _a.awayTeamId;

    var homeTeamGoals = 0;
    var awayTeamGoals = 0;

    if (sportnet_utilities_1.getProp(match, ['protocol', 'events'], []).length) {
      homeTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
        if (e.team === homeTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
          return acc + 1;
        }

        return acc;
      }, homeTeamGoals);
      awayTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
        if (e.team === awayTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
          return acc + 1;
        }

        return acc;
      }, awayTeamGoals);
    } else if (match.protocol) {
      homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
        if (e.team === homeTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
          return acc + 1;
        }

        return acc;
      }, homeTeamGoals);
      awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
        if (e.team === awayTeamId && e.eventType === 'goal' && e.phase === 'shootout') {
          return acc + 1;
        }

        return acc;
      }, awayTeamGoals);
    }

    return {
      homeTeamGoals: homeTeamGoals,
      awayTeamGoals: awayTeamGoals
    };
  };

  var renderClosedMatch = function (match) {
    var _a = exports.getTeamsIds(match),
        homeTeamId = _a.homeTeamId,
        awayTeamId = _a.awayTeamId;

    var _b = exports.getGoalsByTeams(match),
        homeTeamGoals = _b.homeTeamGoals,
        awayTeamGoals = _b.awayTeamGoals;

    var goalsByMatchPart = getGoalsByMatchPart(match);
    var sportSectorPhases = getSportSectorPhases(match.rules.sport_sector);

    var _c = getShootoutGoals(match),
        homeTeamPenaltyGoals = _c.homeTeamGoals,
        awayTeamPenaltyGoals = _c.awayTeamGoals;

    var phases = sportSectorPhases.filter(function (s) {
      return s._id === match.rules.sport_sector;
    });
    var penaltyPhase = phases.find(function (i) {
      return i._id === 'shootout';
    });
    return React.createElement(React.Fragment, null, React.createElement("div", {
      style: {
        fontSize: polished_1.rem(24)
      }
    }, React.createElement("span", {
      style: tslib_1.__assign({}, homeTeamGoals > awayTeamGoals && {
        fontWeight: 'bold'
      })
    }, homeTeamGoals), ' ', ":", ' ', React.createElement("span", {
      style: tslib_1.__assign({}, homeTeamGoals < awayTeamGoals && {
        fontWeight: 'bold'
      })
    }, awayTeamGoals)), React.createElement("div", {
      style: {
        fontSize: polished_1.rem(11)
      }
    }, "(", Object.keys(goalsByMatchPart).map(function (phase) {
      return (goalsByMatchPart[phase][homeTeamId] || 0) + ":" + (goalsByMatchPart[phase][awayTeamId] || 0);
    }).join(', '), ")"), (!!homeTeamPenaltyGoals || !!awayTeamPenaltyGoals) && React.createElement("div", null, !!penaltyPhase && penaltyPhase.label, React.createElement("br", null), homeTeamPenaltyGoals + ":" + awayTeamPenaltyGoals));
  };

  var getMatchState = function (match) {
    if (match.closed && match.protocol) {
      return renderClosedMatch(match);
    }

    return ' - ';
  };

  if ((!data.competitionId && !data.teamId || data.data && data.data.matches.length === 0) && renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('matchesList'));
  }

  return React.createElement(Wrapper, null, data.data && data.data.matches.map(function (match) {
    if (match.closed) {// const goals = getGoalsByMatchPart(match);
    }

    var homeTeam = match.teams.find(function (t) {
      return t.additionalProperties && t.additionalProperties.homeaway === 'home';
    }) || match.teams[0];
    var awayTeam = match.teams.find(function (t) {
      return t.additionalProperties && t.additionalProperties.homeaway === 'away';
    }) || match.teams[1];
    return React.createElement(Match, {
      key: match._id
    }, React.createElement(AdditionalMatchInfo, {
      align: "left"
    }, React.createElement("b", null, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_DATE_FORMAT)), date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_TIME_FORMAT)), React.createElement(PrimaryMatchInfo, null, React.createElement(Team, {
      align: "left"
    }, React.createElement(TeamName, null, homeTeam.name), React.createElement(TeamLogo, {
      width: 25,
      src: "" + homeTeam.organization.logo_public_url
    })), React.createElement(ScoreBoard, null, React.createElement(TimePlace, null, date_fns_1.format(new Date(match.startDate), _config_1["default"].DEFAULT_DATE_FORMAT + " " + _config_1["default"].DEFAULT_TIME_FORMAT)), React.createElement(Score, null, getMatchState(match))), React.createElement(Team, {
      align: "right"
    }, React.createElement(TeamLogo, {
      width: 25,
      src: "" + awayTeam.organization.logo_public_url
    }), React.createElement(TeamName, null, awayTeam.name))), React.createElement(AdditionalMatchInfo, null, React.createElement("div", null, match.competition.name), React.createElement("div", null, React.createElement("b", null, match.sportGround.city))));
  }));
};

exports["default"] = WidgetMatchesList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;